type NavigationGuard = () => boolean;
const guards = new Set<NavigationGuard>();
export function registerNavigationGuard(guard: NavigationGuard) {
  guards.add(guard);
  return () => {
    guards.delete(guard);
  };
}
export function mayNavigate(): boolean {
  return [...guards].every((guard) => guard());
}
